import React from 'react'
import Contact from '../public/Contact'
import MenuDoctor from './navDoctor/MenuDoctor'

function ContactMedical() {
    return (
        <div>
            <MenuDoctor menuActive={'contact'}/>
            <Contact disabledMenu />
        </div>
    )
}

export default ContactMedical